// extracted by mini-css-extract-plugin
export default {"rating":"sE-z","numberOfStars":"tE-z","count":"uE-z","barGraphSpacing":"vE-z","barGraph":"wE-z"};